import { useEffect, useState } from 'react';

import { useServerTimeOffset } from '../../stores';

/**
 * Returns a ticking `Date` representing the current server time.
 *
 * Only the component that calls this hook re-renders every `intervalMs`.
 * No context is involved — the tick is purely local state.
 *
 * @param intervalMs - Tick interval in milliseconds (default: 1000)
 */
export function useServerClock(intervalMs = 1_000): Date {
  const { timeOffset } = useServerTimeOffset();
  const [now, setNow] = useState(() => new Date(Date.now() + timeOffset));

  useEffect(() => {
    const serverNow = Date.now() + timeOffset;

    // Immediately sync to the latest offset
    setNow(new Date(serverNow));

    const id = window.setInterval(() => {
      const serverNow = Date.now() + timeOffset;
      setNow(new Date(serverNow));
    }, intervalMs);

    return () => {
      window.clearInterval(id);
    };
  }, [timeOffset, intervalMs]);

  return now;
}
